// extracted by mini-css-extract-plugin
export default {"warningModal":"ReportGenerate_warningModal__zw+s+","buttonBlock":"ReportGenerate_buttonBlock__wQmXC"};